import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

/**
 * Vertical (desktop) / horizontal (mobile) listing wizard progress.
 * Completed and already-visited steps are tappable so hosts can jump back.
 */
const ListingStepper = ({
  steps,
  currentStep,
  maxReachedStep,
  minStep,
  onSelect,
  disabled = false,
}) => {
  const listRef = useRef(null);

  useEffect(() => {
    const current = listRef.current?.querySelector('[aria-current="step"]');
    current?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }, [currentStep]);

  return (
    <nav className="listing-stepper" aria-label="Listing progress">
      <ol className="listing-stepper-list" ref={listRef}>
        {steps.map((step, index) => {
          const displayNum = index + 1;
          const isCurrent = step.id === currentStep;
          const isComplete = step.id < currentStep;
          const isReachable = !disabled && !isCurrent && step.id >= minStep && step.id <= maxReachedStep;
          const status = isCurrent ? 'current' : isComplete ? 'complete' : 'upcoming';
          const stateLabel = isComplete ? ', completed' : isCurrent ? ', current' : '';

          return (
            <li
              key={step.id}
              className={`listing-stepper-item listing-stepper-item--${status}${isReachable ? ' is-clickable' : ''}`}
            >
              <button
                type="button"
                className="listing-stepper-btn"
                onClick={() => { if (isReachable) onSelect(step.id); }}
                disabled={!isReachable}
                aria-current={isCurrent ? 'step' : undefined}
                aria-label={`${step.label}, step ${displayNum} of ${steps.length}${stateLabel}`}
              >
                <span className="listing-stepper-marker" aria-hidden="true">
                  {isComplete ? <FontAwesomeIcon icon={faCheck} /> : displayNum}
                </span>
                <span className="listing-stepper-label">{step.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default ListingStepper;
